import { IsArray } from "../checks/IsArray"

type blobInput = Blob | string | Uint8Array

/**
 * Converts various data types into a Blob.
 * Accepts single values or arrays of Blob, string, or Uint8Array.
 *
 * @param value - The data to convert to a Blob (single value or array)
 * @param type - Optional MIME type for the Blob (e.g., "application/pdf")
 * @returns A Blob containing the provided data
 *
 * @example
 * ```ts
 * import { ToBlob } from "@pdfking/tfunc"
 *
 * // From string
 * const textBlob = ToBlob("Hello, world!", "text/plain");
 *
 * // From Uint8Array
 * const data = new Uint8Array([1, 2, 3]);
 * const binaryBlob = ToBlob(data, "application/octet-stream");
 *
 * // From array of chunks
 * const chunks = [chunk1, chunk2, chunk3];
 * const pdfBlob = ToBlob(chunks, "application/pdf");
 * ```
 */
export const ToBlob = (value: blobInput | blobInput[], type?: string): Blob =>
  new Blob((IsArray(value) ? value : [value]) as unknown as BlobPart[], {
    type,
  })
